/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MediaUrl } from '../models/MediaUrl';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CandidateService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get the download url for the file
     * @param profileId Id of the profile
     * @param category Category of the file
     * @param filename Filename
     * @returns MediaUrl Success
     * @throws ApiError
     */
    public getSelfDownloadUrl(
        profileId: string,
        category: string,
        filename: string,
    ): CancelablePromise<MediaUrl> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/self/profile/{profileId}/{category}/{filename}/download',
            path: {
                'profileId': profileId,
                'category': category,
                'filename': filename,
            },
            errors: {
                404: `Not found`,
            },
        });
    }

    /**
     * Delete the file
     * @param profileId Id of the profile
     * @param category Category of the file
     * @param filename Filename
     * @returns void
     * @throws ApiError
     */
    public deleteMediaByFilename(
        profileId: string,
        category: string,
        filename: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/self/profile/{profileId}/{category}/{filename}',
            path: {
                'profileId': profileId,
                'category': category,
                'filename': filename,
            },
            errors: {
                404: `Not found`,
            },
        });
    }

    /**
     * Get the upload url for the file
     * @param profileId Id of the profile
     * @param category Category of the file
     * @param filename Filename
     * @returns MediaUrl Success
     * @throws ApiError
     */
    public getSelfUploadUrl(
        profileId: string,
        category: string,
        filename: string,
    ): CancelablePromise<MediaUrl> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/self/profile/{profileId}/{category}/{filename}/upload',
            path: {
                'profileId': profileId,
                'category': category,
                'filename': filename,
            },
        });
    }

}
